<template>
  <div class="app-router_cla">
    <router-view v-if="hackReset" />
  </div>
</template>

<script>
import {
  getClinetHeight,
  getClinetWidth,
  getRouterViewHeight
} from '@/utils/utils.js'
import { mapActions, mapGetters } from 'vuex'
import gobal from '@/utils/common.js'

export default {
  data() {
    return {
      hackReset: true,
      loginName: '',
      envList: {
        development: {
          wx_appid: 'wx1ead1a4b2c101240',
          wx_appCallbackAddres: 'https://smartdbs-dev.zkclouds.com/'
        },
        dev: {
          wx_appid: 'wx1ead1a4b2c101240',
          wx_appCallbackAddres: 'https://smartdbs-dev.zkclouds.com/'
        },
        alpha: {
          wx_appid: 'wx1ead1a4b2c101240',
          wx_appCallbackAddres: 'https://alpha.dbs.zkclouds.com/'
        },
        cn: {
          wx_appid: 'wx62d41b825ffea59d',
          wx_appCallbackAddres: 'https://console.dbs.zkclouds.com/'
        },
        sg: {
          wx_appid: 'wxbcf3925a69ce8271',
          wx_appCallbackAddres: 'https://sg.zkclouds.com/'
        }
      }
    }
  },
  created() {
    window.addEventListener('visibilitychange', function() {
      if (
        document.hidden &&
        gobal.loginName !== localStorage.getItem('loginName')
      ) {
        gobal.loginName = localStorage.getItem('loginName') // 只有当初始创建的aaa不等于localStorage里面的userId的时候去覆盖掉这个aaa
        const loginInfo = localStorage.getItem('loginInfo')
        const pwdStrength = localStorage.getItem('pwdStrength')
        const role = localStorage.getItem('role')

        sessionStorage.setItem('loginName', gobal.loginName)
        sessionStorage.setItem('loginInfo', loginInfo)
        sessionStorage.setItem('pwdStrength', pwdStrength)
        sessionStorage.setItem('role', role)
        if (localStorage.getItem('companyId')) {
          sessionStorage.setItem('companyId', localStorage.getItem('companyId'))
        }
      }
    })
  },
  mounted() {
    this.loginName = localStorage.getItem('loginName')
    if (this.$route.path !== '/') {
      this.getMenuPermission(this.$router)
    }
    window.addEventListener('resize', this.getWindowInfo, true)
    this.getWindowInfo()
    this.setWXInfo()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowInfo, true)
  },
  methods: {
    ...mapActions(['getMenuPermission', 'setWinInfo']),
    setWXInfo() {
      let env = process.env.NODE_ENV
      try {
        this.$root.wxAppid = this.envList[env]['wx_appid']
        this.$root.wxCallbackAddress = this.envList[env]['wx_appCallbackAddres']
      } catch (error) {
        this.$root.wxAppid = 'wx1ead1a4b2c101240'
        this.$root.wxCallbackAddress = 'https://alpha.dbs.zkclouds.com/'
        console.log(error)
      }
    },
    getWindowInfo() {
      setTimeout(() => {
        this.setWinInfo({
          clientWidth: getClinetWidth(),
          clientHeight: getClinetHeight(),
          routerViewHeight: getRouterViewHeight()
        })
      }, 500)
    }
  },
  watch: {
    resourceTree(val) {
      this.$root.resourceTree = val
    },
    loginName(val) {
      if (val) {
        this.hackReset = false
        this.$nextTick(() => {
          this.hackReset = true
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      accessedRouters: 'getAccessedRouters',
      IsLoad: 'getIsLoad',
      resourceTree: 'getResourceTree',
      getTheme: 'getTheme'
    })
  }
}
</script>

<style lang="less">
@import '~@/styles/var.less';
html,
body,
.app-router_cla {
  .basePage;
  overflow: hidden;
}

.el-input-group__append {
  color: @lightBgColor;
  background: @themeColor;
}
.el-input-group__append:hover {
  background: #71c159;
  border-color: #71c159;
  color: @lightBgColor;
}
/**********drawer */
//抽屉//element-ui的drawer固定底部按钮
.el-drawer__wrapper {
  .el-drawer__header {
    padding: 30px;
    border: 1px solid #e8e8e8;
  }
  .el-drawer__body {
    overflow-y: scroll;
    margin-bottom: 50px;
  }

  //抽屉//去掉element-ui的drawer标题选中状态
  :focus {
    outline: 0 !important;
  }
  .demo-drawer__content {
    padding: 0 20px;
  }
  .demo-drawer__footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 30px;
    text-align: center;
    background-color: white;
  }
}

/**** */
.el-scrollbar__bar {
  &.is-vertical {
    width: 4px; //滚动条宽度
  }
}
.el-scrollbar__thumb {
  ////可设置滚动条颜色
  background-color: #7f7f7f;
}
.intro {
  background: #edf0f5;
  width: 100%;
  height: 100vh;
  background-size: cover;
}
@keyframes hue-rotate {
  from {
    -webkit-filter: hue-rotate(0);
    -moz-filter: hue-rotate(0);
    -ms-filter: hue-rotate(0);
    filter: hue-rotate(0);
  }
  to {
    -webkit-filter: hue-rotate(30deg);
    -moz-filter: hue-rotate(30deg);
    -ms-filter: hue-rotate(30deg);
    filter: hue-rotate(30deg);
  }
}

[v-cloak] {
  display: none;
}
.tabs {
  font-size: 14px !important;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  overflow: hidden;
}
.tabs-bar {
  position: relative;
}
.tabs-bar:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: #d7dde4;
  margin-top: -1px;
  position: absolute;
  bottom: 0px;
}

.tabs-tab {
  display: inline-block;
  padding: 10px 13px;
  background: #fff;
  cursor: pointer;
  position: relative;
}
.tabs-tab-active {
  color: @themeColor;
  border-bottom: 3px solid @themeColor;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
}

html,
body {
  -webkit-text-size-adjust: none;
  font-size: 16px;
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #dcdfe6;
}
.el-input__inner {
  height: 35px;
  line-height: 35px;
}

.el-table--small td,
.el-table--small th {
  padding: 2px 0;
}
#nprogress .bar {
  background: rgb(0, 193, 222) !important; //自定义颜色
}

.el-popover {
  max-width: 35% !important;
}
.el-table {
  thead tr {
    th {
      background: #f3f4f5;
      height: 43px;
      padding: 2px 0;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      letter-spacing: 0;
    }
  }

  tbody {
    tr {
      td {
        padding: 0px !important;
        min-width: 0;
        height: 49px;
        box-sizing: border-box;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border: none;
        border-bottom: 1px solid rgb(227, 232, 238, 0.4);
        padding: 2px 0;
      }
      .cell {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .el-table__row--striped {
      td {
        background-color: #f5f7f9;
      }
    }
  }
}
.el-menu--popup {
  .el-menu-item {
    color: #fff;
  }
}
.el-date-editor--daterange.el-input__inner,
.el-date-editor--datetimerange.el-input__inner {
  width: 250px;
}
.el-table .cell {
  word-break: break-word;
}
.el-table__body {
  // 使表格兼容safari，不错位
  width: 100%;
  table-layout: fixed !important;
}

.el-input-group__append {
  .el-button--info {
    color: #fff;
    background-color: #959fa2 !important;
    border-color: #959fa2 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue